import { useTranslation } from 'react-i18next'
import { common } from '@ocean/ui'
import PageHeaderLayout, { PageHeaderSegment } from 'layouts/PageHeaderLayout'
import { GoToButton } from 'components/common'
import { namespace } from 'modules/Notifications/localization'

const { SectionTitle } = common

const I18_PATH = `${namespace}:notifications`

const NotificationsHeader: React.FC = () => {
  const { t } = useTranslation()
  return (
    <PageHeaderLayout segmentId='content'>
      <PageHeaderSegment segmentId='top'>
        <GoToButton dataTest='NotificationsHeaderGoToButton' />
      </PageHeaderSegment>
      <PageHeaderSegment segmentId='title'>
        <SectionTitle title={t(`${I18_PATH}.title`)} />
      </PageHeaderSegment>
    </PageHeaderLayout>
  )
}

export default NotificationsHeader
